import {
    numberWithCommas,
    secondsToHumanReadableDuration,
    metersToKiloMeters,
    unixStringToHumanReadable,
    getZoomLevelFromDistance,
    unixTimestampToRelativeHumanReadable,
} from '../../common/utils';

export const transformSegments = (segments) => {
    if (segments && segments.length) {
        return segments.map((segment) => {
            return {
                id: segment.id,
                name: segment.fullName,
                date: unixStringToHumanReadable(segment.startTime),
                avatar: segment.profilePicture,
                litterCount: numberWithCommas(segment.litterCount),
                distance: segment.distance
                    ? metersToKiloMeters(segment.distance)
                    : '0 M',
                zoomLevel: segment.distance
                    ? getZoomLevelFromDistance(segment.distance)
                    : 13.0,
                duration: segment.duration
                    ? secondsToHumanReadableDuration(segment.duration)
                    : '0 SEC',
                location:
                    segment.location && segment.location.length
                        ? segment.location.map((location) => {
                              return {
                                  lat: parseFloat(location.lat),
                                  lng: parseFloat(location.long),
                              };
                          })
                        : [],
            };
        });
    } else {
        return [];
    }
};

export const transformNotifications = (notifications) => {
    if (notifications && notifications.length) {
        return notifications.map((notification) => {
            return {
                id: notification.id,
                title: notification.title,
                date: unixTimestampToRelativeHumanReadable(
                    notification.createdAt,
                ),
                message: notification.message,
                contextKey: notification.contextKey,
                contextValue: notification.contextValue,
            };
        });
    } else {
        return [];
    }
};
